export default function About() {
  const stats = [
    { number: '28', label: '創業からの年数', suffix: '年' },
    { number: '1,850', label: '累計取引実績', suffix: '件' },
    { number: '98.5', label: 'お客様満足度', suffix: '%' }
  ];

  return (
    <section id="about" className="py-32 bg-white">
      <div className="max-w-[1120px] mx-auto px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center justify-center h-8 px-4 bg-[#F5F5F5] rounded-full mb-6">
            <span className="text-[10px] tracking-[0.15em] text-[#666666] font-medium" style={{ fontFamily: "'Inter', sans-serif" }}>
              ABOUT US
            </span>
          </div>
          <h3
            className="text-[38px] leading-tight font-normal text-[#1A1A1A]"
            style={{ fontFamily: "'Noto Serif JP', serif" }}
          >
            確かな実績と信頼で
            <br />
            お客様の資産をお守りします
          </h3>
        </div>

        <div className="flex gap-16">
          <div className="w-[45%] space-y-0">
            {stats.map((stat, index) => (
              <div key={index}>
                <div className="py-10">
                  <div
                    className="text-[52px] font-medium mb-4"
                    style={{ fontFamily: "'Noto Serif JP', serif", color: '#8B4545' }}
                  >
                    {stat.number}
                    <span className="text-[32px]">{stat.suffix}</span>
                  </div>
                  <p
                    className="text-[14px] text-[#666666] leading-relaxed"
                    style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                  >
                    {stat.label}
                    <br />
                    {index === 0 && '1996年の創業以来、一貫して高級住宅市場に特化'}
                    {index === 1 && '東京都心部を中心とした高額物件の取引実績'}
                    {index === 2 && 'お客様アンケートに基づく総合満足度評価'}
                  </p>
                </div>
                {index < stats.length - 1 && <div className="h-px bg-[#E8E8E8]"></div>}
              </div>
            ))}
          </div>

          <div className="w-[55%] relative">
            <div className="relative h-full flex items-center justify-center">
              <div
                className="absolute rounded-[120px] opacity-60"
                style={{
                  width: '420px',
                  height: '280px',
                  background: 'linear-gradient(135deg, #F9F6F2 0%, #F2EDE7 100%)',
                  top: '10%',
                  left: '5%'
                }}
              ></div>
              <div
                className="absolute rounded-[120px] opacity-60"
                style={{
                  width: '380px',
                  height: '260px',
                  background: 'linear-gradient(135deg, #F2EDE7 0%, #EBE4DC 100%)',
                  top: '25%',
                  left: '15%'
                }}
              ></div>
              <div
                className="absolute rounded-[120px] opacity-60"
                style={{
                  width: '340px',
                  height: '240px',
                  background: 'linear-gradient(135deg, #EBE4DC 0%, #E4DDD3 100%)',
                  top: '40%',
                  left: '25%'
                }}
              ></div>
              <div className="relative z-10 text-center px-12">
                <p
                  className="text-[15px] leading-relaxed text-[#333333]"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  私たちは、高級住宅市場における豊富な経験と専門知識を活かし、
                  お客様一人ひとりのニーズに寄り添った最適なソリューションをご提案いたします。
                  <br />
                  <br />
                  不動産取引における全てのプロセスを、
                  誠実かつ丁寧にサポートさせていただきます。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
